module.exports = __webpack_public_path__ + "img/hamburger_orange.17cfa907.svg";